import {handleAction, handleSubState} from 'uix/actions'
import {dict, has, size, keys, mergeDeep} from 'ldash'
import log from 'uix/logging'
import {persistReducer} from 'uix/persist'

import {
  setTreeList,
  setTreeListLoading,
  setTreeListError,
  setTreeRecords,
  DBLoadActivity,
  progressTreeRecords,
  setTrackedRecordsFields,
  setTreeFieldSchema,
  setTrackedSkips,
  // clipboard
  storeIdsForClipboard,
} from './actions'

const db = handleSubState('db', [
  handleAction(
    setTreeRecords,
    (db, {payload}) => {
      let {byId} = db
      let {data, links} = payload
      let physicals = dict(data.map(e => [e.otid, e]))
      // map link otids to data
      let resolved = dict(links.map(e => [e.otid, physicals[e.otlink]]))
      byId = mergeDeep(db.byId, physicals, resolved)
      return {...db, byId}
    },
    {
      byId: {},
      list: {}, // key: listid, value: list of records from fast tree list
      list_loading: {}, // key: listid, value: is_loading
      activity: {},
      trackedFields: {},
      trackedSkips: {}, // key: datatype, value: namespace that is not available
      schema: {}, // key: datatype, value: fields
      progressTreeFields: {},
    }
  ),
  handleAction(setTreeList, (db, {payload}) => {
    let {listid, data, paramsKey} = payload
    let list = {...db.list, [listid]: data}
    let list_loading = {...db.list_loading, [listid]: {params: paramsKey, loading: false}}
    return {...db, list, list_loading}
  }),
  handleAction(setTreeListLoading, (db, {payload}) => {
    let {listid, paramsKey} = payload
    let list_loading = {...db.list_loading, [listid]: {params: paramsKey, loading: true}}
    return {...db, list_loading}
  }),
  handleAction(setTreeListError, (db, {payload}) => {
    let {listid, error} = payload
    let list_loading = {
      ...db.list_loading,
      [listid]: {...db.list_loading[listid], error, loading: false},
    }
    return {...db, list_loading}
  }),

  handleAction(DBLoadActivity, ({activity, ...db}, {payload}) => {
    return {...db, activity: {...activity, ...payload}}
  }),
  handleAction(setTrackedRecordsFields, ({trackedFields, ...db}, {payload}) => {
    return {...db, trackedFields: {...trackedFields, ...payload}}
  }),
  handleAction(setTreeFieldSchema, ({schema, ...db}, {payload}) => {
    return {...db, schema: payload.schema}
  }),
  handleAction(setTrackedSkips, ({trackedSkips, ...db}, {payload}) => {
    return {...db, trackedSkips: payload.trackedSkips}
  }),
  handleAction(progressTreeRecords, ({progressTreeFields, ...db}, {payload}) => {
    return {...db, progressTreeFields: {...progressTreeFields, [payload.batchId]: payload}}
  }),
])

const clipboard = handleSubState('clipboard', [
  persistReducer(
    handleAction(
      storeIdsForClipboard,
      ({ops, ...clipboard}, {payload}) => {
        return {...clipboard, ops: [...ops, {...payload, dt: new Date().toISOString()}].slice(-50)}
      },
      {ops: []}
    ),
    {key: 'uix_clipboard', whitelist: ['ops']}
  ),
])

export const data = [db, clipboard]
